import { useState } from 'react'
import type { QrGenerateResponse } from '../types/api'
import { apiClient } from '../services/api'

export default function QrCodeGenerator() {
  const [magoId, setMagoId] = useState('')
  const [brand, setBrand] = useState('magolink')
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<QrGenerateResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleDownload = () => {
    if (!result) return
    const link = document.createElement('a')
    link.href = `data:image/png;base64,${result.qr_image}`
    link.download = `mago-activate-${result.mago_id}.png`
    link.click()
  }

  const handleGenerate = async () => {
    if (!magoId.trim()) return

    setLoading(true)
    setError(null)
    setResult(null)

    try {
      const data = await apiClient.generateQrCode(magoId.trim(), brand)
      setResult(data)
    } catch (err: any) {
      const status = err?.status
      if (status === 404) {
        setError('端末が見つかりません')
      } else if (status === 400) {
        setError('アクティベーションコードが設定されていません')
      } else {
        setError('エラーが発生しました')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <h5 className="mb-3">QRコード生成</h5>
      <div className="row g-3 mb-3">
        <div className="col-md-4">
          <label htmlFor="qr-mago-id" className="form-label">端末ID</label>
          <input
            id="qr-mago-id"
            type="text"
            className="form-control"
            placeholder="端末ID"
            value={magoId}
            onChange={(e) => setMagoId(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="qr-brand" className="form-label">ブランド</label>
          <select
            id="qr-brand"
            className="form-select"
            aria-label="ブランド"
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
          >
            <option value="magolink">magolink</option>
            <option value="mimamolink">mimamolink</option>
            <option value="carelink">carelink</option>
          </select>
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleGenerate}
            disabled={loading || !magoId.trim()}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                生成中...
              </>
            ) : (
              '生成'
            )}
          </button>
        </div>
      </div>

      {error && (
        <div role="alert" className="alert alert-danger">
          {error}
        </div>
      )}

      {result && (
        <div className="card">
          <div className="card-body text-center">
            <div
              data-testid="qr-result-mago-id"
              className="fw-bold mb-3"
              style={{ fontSize: '1.5rem' }}
            >
              端末番号: {result.mago_id}
            </div>
            <img
              role="img"
              aria-label="QR Code"
              src={`data:image/png;base64,${result.qr_image}`}
              alt="QR Code"
              className="img-fluid mb-3"
              style={{ maxWidth: '300px', cursor: 'pointer' }}
              title="クリックでダウンロード"
              onClick={handleDownload}
            />
            <p className="text-muted mt-2">
              マゴリンクアプリをインストール後に、アプリから読み取ってください
            </p>
            <div className="mt-2">
              <small className="text-muted">Deep Link:</small>
              <div className="text-break">{result.deep_link}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
